import Cookies from "js-cookie";

const ALERT_BANNER_COOKIE_NAME = "alertBannerInteraction";
const DAYS_TO_HIDE_ALERT_BANNER_AFTER_INTERACTION = 1;

/**
 * A custom element that renders an alert banner.
 * The close button should dismiss the banner and set a cookie
 * to prevent the banner's display for a given amount of time.
 *
 * @module publica-alert-banner
 * @description
 * A custom element for rendering a dismissable alert banner
 */
export class AlertBanner extends HTMLElement {
	closeButton: Element | null | undefined;

	constructor() {
		super();
	}

	connectedCallback() {
		this.closeButton = this.querySelector("button[slot='close']");

		if (this.closeButton) {
			this.closeButton.addEventListener("click", this.handleClose);
		}

		this.attachShadow({ mode: "open" });

		const template = document.createElement("template");

		template.innerHTML = `
			<div data-element="alert-banner" part="base">
				<style>
					[part="banner"] {
						background-color: var(--color-primary-dark);
					}
					[part="content"] {
						box-sizing: border-box;
						align-items: center;
						max-width: var(--container-max-utility);
						margin-inline: auto;
						padding-block: 0.5rem;
						padding-inline: var(--container-gutter);
						display: flex;
						gap: 1.5rem;
						justify-content: space-between;
					}
				</style>
				<div part="banner">
					<div part="content">
						<slot></slot>
						<slot name="close"></slot>
					</div>
				</div>
			</div>
		`
			.replaceAll(/\s\s+/g, " ")
			.trim();

		this.shadowRoot?.append(template.content.cloneNode(true));
	}

	/**
	 * When closing the banner, add a cookie to let us know
	 * that we shouldn't display the banner again.
	 */
	handleClose = () => {
		Cookies.set(ALERT_BANNER_COOKIE_NAME, "true", {
			expires: DAYS_TO_HIDE_ALERT_BANNER_AFTER_INTERACTION,
		});
		this.style.display = "none";
	};
}
